import type {PageRouteConfig} from '@router';

import CpcBuy from 'modules/Cpc/Buy/CpcBuy';
import {routes} from 'routes/routes';

export function createCpcBuyFlowRoute(): PageRouteConfig {
  return {
    element: <CpcBuy />,
    layout: {
      title: 'کلیک',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.CPC_LIST,
      linkWithConfirmation: true,
      modalTitle: 'خروج از پروسه ساخت کلیک؟',
      modalText: 'با خروج از پروسه، اطلاعاتی که ثبت کردید ذخیره نخواهد شد.'
    }
  };
}
